import React from 'react';

const SerialDetailsModal = ({ isOpen, onClose, item, type }) => {
  if (!isOpen || !item) return null;

  const isBattery = type === 'battery';

  const formatDate = (d) => {
    if (!d) return '-';
    const s = String(d);
    // If already YYYY-MM-DD, return as is
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
    // If ISO with time, take the date part without converting timezone
    if (s.includes('T')) {
      const datePart = s.split('T')[0];
      if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) return datePart;
    }
    // Fallback: construct local date string (YYYY-MM-DD) without UTC shift
    try {
      const dt = new Date(s);
      if (isNaN(dt)) return s || '-';
      const y = dt.getFullYear();
      const m = String(dt.getMonth() + 1).padStart(2, '0');
      const da = String(dt.getDate()).padStart(2, '0');
      return `${y}-${m}-${da}`;
    } catch {
      return s || '-';
    }
  };

  const ageText = (receivedDate) => {
    if (!receivedDate) return '-';
    const now = new Date();
    const start = new Date(receivedDate);
    const diffDays = Math.floor((now - start) / (1000 * 60 * 60 * 24));
    if (diffDays < 30) return `${diffDays} วัน`;
    const months = Math.floor(diffDays / 30);
    return `${months} เดือน`;
  };

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className={`modal-header ${isBattery ? 'bg-primary' : 'bg-info'} text-white`}>
            <h5 className="modal-title thai-text">
              <i className={`me-2 fas ${isBattery ? 'fa-battery-three-quarters' : 'fa-plug'}`}></i>
              ข้อมูล{isBattery ? 'แบตเตอรี่' : 'ชาร์จเจอร์'} - {item.serial}
            </h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            {/* Serial & status summary */}
            <div className="row mb-4">
              <div className="col-md-6">
                <div className="bg-light rounded p-3 h-100">
                  <div className="d-flex align-items-center mb-2">
                    <span className="badge bg-dark fs-6">{item.serial}</span>
                    <span className="badge bg-success ms-2">{(item.status === 'available' || item.status === 'พร้อมขาย') ? 'พร้อมขาย' : (item.status === 'reserved' || item.status === 'ติดจอง') ? 'ติดจอง' : item.status || '-'}</span>
                  </div>
                  <div className="text-muted">
                    อายุสินค้า: {ageText(item.receivedDate)}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="bg-light rounded p-3 h-100">
                  <div className="mb-2"><strong>ผู้จอง:</strong> {item.reserver || '-'}</div>
                  <div className="mb-2"><strong>วันรับเข้า:</strong> {formatDate(item.receivedDate)}</div>
                  <div className="mb-2"><strong>วันบันทึก:</strong> {formatDate(item.entryDate)}</div>
                </div>
              </div>
            </div>

            {/* Product details */}
            <h6 className="text-primary thai-text"><i className="fas fa-list me-2"></i>รายละเอียดสินค้า</h6>
            <div className="row g-3">
              <div className="col-md-4">
                <div className="border rounded p-3 h-100">
                  <div className="mb-2"><strong>ยี่ห้อ:</strong> {item.brand || '-'}</div>
                  <div className="mb-2"><strong>ความจุ:</strong> {item.capacity || '-'} {isBattery ? 'Ah' : 'A'}</div>
                  {isBattery ? (
                    <div className="mb-2"><strong>BMS:</strong> {item.bmsOrType || '-'}</div>
                  ) : (
                    <div className="mb-2"><strong>ประเภท:</strong> {item.bmsOrType || '-'}</div>
                  )}
                  {isBattery && (
                    <div className="mb-2"><strong>คูลอมป์:</strong> {item.coulomb || '-'}</div>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <div className="border rounded p-3 h-100">
                  <div className="mb-2"><strong>สภาพสินค้า:</strong> {item.condition === 'new' ? 'ใหม่' : item.condition === 'used' ? 'มือสอง' : (item.condition || '-')}</div>
                  <div className="mb-2"><strong>สถานะ:</strong> {(item.status === 'available' || item.status === 'พร้อมขาย') ? 'พร้อมขาย' : (item.status === 'reserved' || item.status === 'ติดจอง') ? 'ติดจอง' : item.status || '-'}</div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="border rounded p-3 h-100">
                  <div className="mb-2"><strong>หมายเหตุ:</strong> {item.note || '-'}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>ปิด</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SerialDetailsModal;